import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Incomplete18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_597)'>
      <path
        d='M9 1.75C13.0041 1.75 16.25 4.99594 16.25 9C16.25 13.0041 13.0041 16.25 9 16.25C8.51484 16.25 8.04154 16.2025 7.58425 16.112L7.29315 17.5835C7.84579 17.6928 8.41658 17.75 9 17.75C13.8325 17.75 17.75 13.8325 17.75 9C17.75 4.16751 13.8325 0.25 9 0.25C8.41658 0.25 7.84579 0.307202 7.29315 0.416531L7.58425 1.88801C8.04154 1.79755 8.51484 1.75 9 1.75Z'
        fill='currentColor'
      />
      <path
        d='M1.72425 13.8622C2.36285 14.816 3.18396 15.6371 4.13783 16.2757L4.97231 15.0293C4.18137 14.4998 3.50023 13.8186 2.9707 13.0277L1.72425 13.8622Z'
        fill='currentColor'
      />
      <path
        d='M4.13783 1.72425C3.18395 2.36285 2.36285 3.18396 1.72425 4.13784L2.9707 4.97231C3.50022 4.18137 4.18136 3.50023 4.97231 2.9707L4.13783 1.72425Z'
        fill='currentColor'
      />
      <path
        d='M0.416527 7.29315C0.197868 8.39843 0.197868 9.60156 0.416527 10.7068L1.88801 10.4157C1.70708 9.50117 1.70708 8.49883 1.88801 7.58426L0.416527 7.29315Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_597'>
        <rect
          width='18'
          height='18'
          fill='white'
          transform='matrix(0 1 -1 0 18 0)'
        />
      </clipPath>
    </defs>
  </Svg>
);

Incomplete18.displayName = 'Incomplete18';
export default Incomplete18;
